<template>
  <div class="content-center-wrapper">
    <div class="white-container d-flex align-items-center justify-content-center">
      <div class>
        <form class="text-center">
          <div class="mb-4">
            <img src="@/assets/img/logos/qqq.png" height="auto" width="150" />
          </div>

          <div class="d-flex flex-wrap justify-content-center">
            <div class="selection-box">
              <router-link to="setup-organization">
                <label>
                  HO
                  <br />Installation
                </label>
              </router-link>
            </div>

            <!-- <div class="selection-box">
              <router-link to="cinema-url-installation">
                <label>
                  Cinema
                  <br />Installation
                </label>
              </router-link>
            </div>-->

            <!--<div class="selection-box">
              <router-link to="database-configuration">
                <label>
                  Box
                  <br>Office
                </label>
              </router-link>
            </div>

            <div class="w-100"></div>

            <div class="selection-box">
              <router-link to="database-configuration">
                <label>Kiosk</label>
              </router-link>
            </div>

            <div class="selection-box">
              <router-link to="database-configuration">
                <label>Signage</label>
              </router-link>
            </div>

            <div class="selection-box">
              <router-link to="database-configuration">
                <label>F & B</label>
              </router-link>
            </div>-->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService";

export default {
  beforeMount() {
    this.getSetupStatus();
  },
  methods: {
    getSetupStatus: function() {
      SetupService.SetupStatus()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (!data.isSetupAllowed) {
              this.$router.push({
                path: data.route
              });
            }
          } else {
            this.$router.push({
              name: "Error404"
            });
          }
        })
        .catch(err => {
          this.$router.push({
            name: "Error404"
          });
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/selectInstallationType.vue